import { render } from "./ChatLIst.vue?vue&type=template&id=1e1766d0&scoped=true"
import script from "./ChatLIst.vue?vue&type=script&lang=js"
export * from "./ChatLIst.vue?vue&type=script&lang=js"

import "./ChatLIst.vue?vue&type=style&index=0&id=1e1766d0&lang=scss&scoped=true"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e1766d0"]])

export default __exports__